/* eslint-disable @typescript-eslint/no-explicit-any */
import styled from 'styled-components';
import rtl from 'styled-components-rtl';
import { toRem, baseVariables, contextualVariable } from '@marriott/mi-ui-library';

/**
 * Styles dedicated to the StaticHotelSearchField list and its container.
 * Keep generic dropdown/search styles in SearchFieldCategories.styles.tsx.
 */
export const StyledStaticHotelSearchField = styled.div<{
  $isDesktopView?: boolean;
}>`
  ${rtl`
    .custom-branded-scrollbar {
      height: auto!important;
      overflow-y: auto;
      scrollbar-color: ${contextualVariable.accentColor} #f1f1f1;
      @media ${baseVariables.mediaQuery.lg} {
      max-height:${toRem(450)}!important;
      }
    }

    .list-reset {
      list-style: none;
      margin: 0;
      padding: 0;
    }

    .static-list {
      list-style: none;
      margin: 0;
      padding: 0;
      padding-top: 1rem;
    }

    .metro-group {
      list-style: none;
      margin: 0;
      padding: 0;
      padding-top: ${toRem(8)};
    }
    .metro-group--first {
      padding-top: 0;
    }

    .metro-header {
      text-transform: none; 
      font-weight: 700;
      font-size: ${toRem(16)};
      line-height: ${toRem(20)};
      margin-bottom: ${toRem(8)};
    }
    .metro-header--uppercase {
      text-transform: uppercase;
      letter-spacing: 0.02em;
    }

    .metro-hotels {
      list-style: none;
      margin: 0;
      padding: 0;
      padding-top: 0;
    }

    .hotel-row--indent-16 { padding-left: ${toRem(16)}!important; }
    .hotel-row--indent-24 { padding-left: ${toRem(24)}!important; }
    .hotel-row--indent-32 { padding-left: ${toRem(32)}!important; }
    .hotel-row {
      display: block;
      padding: ${toRem(12)} 0;
      cursor: pointer;
      background: ${baseVariables.color.base20};
      border-bottom: ${toRem(1)} solid ${baseVariables.color.neutral20};
      outline: none;
      border-radius:${toRem(8)}
    }

    .hotel-row:hover,
    .hotel-row:focus {
      background: ${baseVariables.color.neutral20}
    }

    .hotel-label {
      font-size: ${toRem(16)};
      font-weight: 500;
    }

    .hotel-code {
      margin-left: 0.5rem;
      color: ${baseVariables.color.neutral60};
      font-weight: 400;
      font-size: ${toRem(15)};
    }

    .no-results {
      padding: ${toRem(8)} 0;
      color: ${baseVariables.color.base10};
    }

    .mobile-input-field {
      height: ${toRem(54)};
      position: sticky;
      top: ${toRem(61)};
      background: ${baseVariables.color.base20};
      z-index: 1;
    }
  `}
`;
